import React, { useMemo } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { Link } from '../link';
import FooterCopyright from './FooterCopyright';
import { getLinkInformation } from '../../utils/functions';
import { Wrapper } from '../../utils/components';

const MenuFooterBottomItem = ({ item }) => {
  const linkInformation = getLinkInformation(
    item.content.internalLink?.value?.link,
    item.content.externalLink.value,
    item.value,
    item.content.internalLink?.value?.pageTitle?.value
  );

  return (
    <li className='footer__navigation--item'>
      <Wrapper
        className='footer__navigation--link'
        tag='span'
        component={linkInformation.link && Link}
        to={linkInformation.link}
      >
        {linkInformation.label && <span>{linkInformation.label}</span>}
      </Wrapper>
    </li>
  );
};

const MenuFooterBottom = ({ langCode, from }) => {
  const { allPages } = useStaticQuery(
    graphql`
      {
        allPages: allLiferayMenuFooterBottom(
          filter: { liferayFields: { title: { eq: "Menu - Footer - Bottom" } } }
        ) {
          nodes {
            liferayFields {
              langCode
            }
            labelLink {
              value
              content {
                internalLink {
                  value {
                    ... on LiferayPageGeneric {
                      link
                      pageTitle {
                        value
                      }
                    }
                    ... on LiferayModuleDetailProduct {
                      link
                      pageTitle: detailPageTitle {
                        value
                      }
                    }
                    ... on LiferayModuleDetailBlog {
                      link
                      pageTitle: detailPageTitle {
                        value
                      }
                    }
                    ... on LiferayModuleDetailIniziative {
                      link
                      pageTitle: detailPageTitle {
                        value
                      }
                    }
                  }
                }
                externalLink {
                  value
                }
                linkNotVisible {
                  value
                }
              }
            }
            copyrightText {
              value
            }
          }
        }
      }
    `
  );

  const menuNode = useMemo(() => {
    return allPages.nodes.find(
      (node) => node.liferayFields.langCode === langCode
    );
  }, [allPages, langCode]);

  const menuItems = useMemo(
    () =>
      menuNode?.labelLink?.filter(
        (item) =>
          (item?.value ||
            item.content?.externalLink?.value ||
            item.content?.internalLink?.value?.link) &&
          !item.content?.linkNotVisible?.value
      ),
    [menuNode]
  );

  return (
    <>
      <nav
        className='footer__bottom-bar'
        data-submodule-name='menu-footer-bottom'
      >
        <ul className='footer__navigation'>
          {menuItems?.map((item, index) => (
            <MenuFooterBottomItem item={item} key={item.value || index} />
          ))}
        </ul>
      </nav>
      <div className='footer__copyright'>
        <FooterCopyright text={menuNode?.copyrightText?.value} from={from} />
      </div>
    </>
  );
};

export default MenuFooterBottom;
